


























































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';

@Component({
    components: {
        SelectedItems,
    },
    computed: {
        ...mapGetters({
            groupingTypes: 'Groupings/getGroupingTypes',
        }),
    },
})
export default class AddGroupingForm extends Mixins(InputFieldMethods) {
    public groupName: string = '';
    public groupType: string = '';

    constructor() {
        super();
    }

    get errorCollection() {
        return this.errors.any();
    }

    get selectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'];
    }

    public addGrouping() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                if (this.selectedProperties.length) {
                    const unitIds = this.selectedProperties.map((pt: any) => pt.id);

                    this.$store.dispatch(Actions.ADD_NEW_GROUPING, {
                        groupingName: this.groupName,
                        groupingType: this.groupType,
                        unitIds,
                    });
                }
            }
        });
    }

    public cancel() {
        this.$store.dispatch(Actions.HIDE_FORM);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_GROUPING_TYPES);
    }
}
